import type { RelationshipValue } from "../components/spreadsheet/relationship.schema";

export type RelationshipOption = {
  value: string;
  label: string;
  avatar?: { seed?: string; url?: string };
};

const toOption = (data: RelationshipValue): RelationshipOption | null => {
  if (!data || !data.id) return null;

  const label =
    (data._meta &&
    typeof data._meta.label === "string" &&
    data._meta.label.trim() !== ""
      ? data._meta.label
      : undefined) || data.id;

  const image = data._meta?.image || null;
  const avatar =
    image && typeof image === "object"
      ? "url" in image && typeof image.url === "string"
        ? { url: image.url }
        : "seed" in image && typeof image.seed === "string"
          ? { seed: image.seed }
          : undefined
      : undefined;

  return avatar ? { value: data.id, label, avatar } : { value: data.id, label };
};

export const seedRelationshipOption = (
  list: RelationshipOption[],
  data: RelationshipValue,
): RelationshipOption[] => {
  const option = toOption(data);
  if (!option) return list;
  if (list.some((o) => o.value === option.value)) return list;
  return [option, ...list];
};
